import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Row, Col, Input, Button, Spin,
} from 'antd';
import AppDatasBody from '../util/AppDatasBody';
import Apps from './Apps';
import AppPortal from './AppPortal';
const store = ['appCollectStore'];
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'collect-app',
  }
  constructor(props) {
    super(props);
    this.scrollTop = 0;
    this.state = {
      col: 4,
    }
  }
  componentDidMount() {
    const { location, appCollectStore: { getCollectList, getMould, setMobxState } } = this.props;
    const id = location.query.id;
    const moduleType = getMould(id);
    this.handleResize();
    setMobxState({ moduleType, current: 1 });
    getCollectList({ module: moduleType, current: 1 });
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps() {
    const { location, appCollectStore: { getCollectList, getMould, setMobxState, moduleType } } = this.props;
    const id = location.query.id;
    const moduleNow = getMould(id);
    if (moduleNow !== moduleType) {
      setMobxState({ moduleType: moduleNow, current: 1, searchValue: '' });
      getCollectList({ module: moduleNow, current: 1 });
      this.handleResize();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (this.appCollectList) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > this.scrollTop) { // 向上翻动
        const { appCollectStore: { getCollectList, collectList, setMobxState, current, collectCount, pageSize, loading } } = this.props;
        const len = toJS(collectList).length;
        if (current * pageSize < collectCount && !loading && len < collectCount) {
          setMobxState({ current: current + 1 });
          getCollectList({ current: current + 1, pageSize });
        }
      }
      this.scrollTop = scrollTop;
    }
  }

  handleResize = () => {
    const cWidth = document.clientWidth || document.body.clientWidth;
    const sWidth = document.scrollWidth || document.body.scrollWidth;
    const docWidth = Math.max(cWidth, sWidth);

    const cHeight = document.clientHeight || document.documentElement.clientHeight;
    const sHeight = document.scrollHeight || document.documentElement.scrollHeight;
    const docHeight = Math.max(cHeight, sHeight) - 444;

    const id = this.props.location.query.id;
    const measure = id === 'theme' ? 300 : 150;
    
    const row = Math.floor(docHeight / measure);
    const appListWidth = ((docWidth * 18) / 24 - 40) * 22 / 24;
    let span = Math.ceil((measure / appListWidth) * 24);
    if (span === 5) span = 6;
    else if (span === 7) span = 8;
    else if (span > 8 && span < 12) span = 12;
    const { col } = this.state;
    const { appCollectStore: { pageSize, setMobxState } } = this.props;
    if (col !== span) this.setState({ col: span });
    if ((24 / span) * row !== pageSize) setMobxState({ pageSize: (24 / span) * row });
  }

  onSearch = () => {
    const { appCollectStore: { searchValue, getCollectList } } = this.props;
    getCollectList({ searchValue, current: 1 });
  }

  render() {
    const { col } = this.state;
    const { location, prefixCls, appCollectStore: { loading, searchValue, setMobxState } } = this.props;
    let { appCollectStore: { collectList } } = this.props;
    collectList = toJS(collectList);
    const id = location.query.id;
    return (
      <div className={prefixCls}>
        <AppDatasBody location={location}>
          <Row className="cs-search-mylist collect-mylist">
            <Col span={4} className={`${prefixCls}-label`}><label>应用名称：</label></Col>
            <Col span={8}>
              <Input placeholder='请输入应用名称' value={searchValue}
                onChange={(e) => setMobxState({ searchValue: e.target.value })}
                onPressEnter={this.onSearch} />
            </Col>
            <Col span={7} offset={5} className={`${prefixCls}-btn`}>
              <Button type="primary" onClick={this.onSearch}>搜索</Button>
              <Button onClick={() => {
                setMobxState({ searchValue: '' });
                this.onSearch();
              }}>重置</Button>
            </Col>
          </Row>
          <Spin spinning={loading}>
            <Row className={`${prefixCls}-content`} ref={c => this.appCollectList = c}>
              {
                collectList && collectList.length > 0 ? collectList.map(t => (
                  <Col span={col} key={t.key}>
                    {
                      id === 'theme' ? (<AppPortal data={t} prefixCls={`${prefixCls}-singleApp`} location={location}/>) : (<Apps data={t} prefixCls={`${prefixCls}-singleApp`} location={location} />)
                    }
                  </Col>
                )) : !loading ? (
                  <div className={`${prefixCls}-NoData`}>
                    <div className="icon-Cloud-No-data" />
                    <p className={`${prefixCls}-NoData-title`}>暂无数据</p>
                  </div>
                ) : null
              }
            </Row>
          </Spin>
        </AppDatasBody>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/collect/AppCollect.js